<template>
    <div v-loading="loading">

        <div class="flex w100">
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">公司</span>
                <el-select  :disabled="disabled_gs" @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="formData.vc_gsname" size="mini" clearable filterable placeholder="请选择公司">
                    <el-option
                            v-for="item in compsData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">客户</span>
                <el-select  :disabled="disabled_kh" @change="changeData($event,'kh')" @clear="clearsearch('kh')" class="marr4" v-model="formData.vc_khname" size="mini" clearable filterable placeholder="请选择客户">
                    <el-option
                            v-for="item in khData"
                            :key="item.i_khid"
                            :label="item.vc_khname"
                            :value="item.i_khid">
                    </el-option>
                </el-select>
            </div>
            <!--<div class="flex w50 alc">
                <span class="marr4 font14 minW58">销售部门</span>
                <el-select  :disabled="disabled" @change="changeData($event,'xsbm')" @clear="clearsearch('xsbm')" class="marr4" v-model="formData.vc_sell_deptName" size="mini" clearable filterable placeholder="请选择销售部门">
                    <el-option
                            v-for="item in groupName"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">销售人员</span>
                <el-select  :disabled="disabled" @change="changeData($event,'xsper')" @clear="clearsearch('xsper')" class="marr4" v-model="formData.vc_sell_uname" size="mini" clearable filterable placeholder="请选择销售人员">
                    <el-option
                            v-for="item in personName"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>-->
        </div>
        <!--<div class="flex w100 marT10">

            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">采购部门</span>
                <el-select  :disabled="disabled" @change="changeData($event,'cgbm')" @clear="clearsearch('cgbm')" class="marr4" v-model="formData.vc_purchase_deptName" size="mini" clearable filterable placeholder="请选择采购部门">
                    <el-option
                            v-for="item in groupName_cg"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">采购人员</span>
                <el-select  :disabled="disabled" @change="changeData($event,'cgper')" @clear="clearsearch('cgper')" class="marr4" v-model="formData.vc_purchase_uname" size="mini" clearable filterable placeholder="请选择采购人员">
                    <el-option
                            v-for="item in personName_cg"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
        </div>-->
        <div class="flex w100 marT10">
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">{{'开始时间'}}</span>
                <el-date-picker
                        :disabled="disabled_time"
                        style="width: 190px"
                        v-model="formData.dt_starttime"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :placeholder="$t('form_select_date')"
                        :picker-options="pickerOptions"
                        @change="changeData($event,'starttime')">
                </el-date-picker>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">{{'结束时间'}}</span>
                <el-date-picker
                        :disabled="disabled_time"
                        style="width: 190px"
                        v-model="formData.dt_endtime"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :placeholder="$t('form_select_date')"
                        :picker-options="pickerOptions2"
                        @change="changeData($event,'endtime')">
                </el-date-picker>
            </div>
        </div>
        <el-table
            ref="table"
            size="mini"
            border
            :data="tableData"
            :height="tableHeight"
            style="width: 100%"
            class="marT10"
            :header-cell-style="{background:'#eef1f6',color:'#000'}">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
            >
                <!--<template slot-scope="scope">
                    <span>{{scope.row.vc_pzname+'/'+scope.row.vc_bzstyle+'/'+scope.row.vc_cd+'/'+scope.row.vc_gykh}}</span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="f_list_price"
                    :label="'挂牌价'"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-input-number @change="inprice(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_list_price" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column  align="center"  width="50"  v-if="formData.i_state==0">
                <template slot="header" slot-scope="scope" >
                    <el-button class="popaddbtn"  @click="addpz" ><i class="el-icon-plus"></i></el-button>
                </template>
                <template  slot-scope="scope">
                    <div class="iconminus" >
                        <span class="minus"   @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="flex w100 marT10">
            <div class="w50 alc txtS">
                <span class="w100 marr4 font14">处理人 </span>
                <span class="w100 font14">{{formData.vc_lruname}}</span>
            </div>
            <div class="w50 alc txtE">
                <span class="w100 marr4 font14">处理日期 </span>
                <span class="w100 font14">{{formData.dt_createtime}}</span>
            </div>
        </div>

        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button v-if="formData.i_state==0&&i_id!=0" type="danger" :disabled="disabled"  size="mini" @click="toVoid()">{{$t('button_nullify')}}</el-button>
            <el-button v-if="formData.i_state==0&&i_id!=0" type="danger" :disabled="disabled" size="mini" @click="toApprove">提交</el-button>
            <el-button v-if="formData.i_state==0" type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="mini">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="mini">取消</el-button>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="15vh"
                width="85%"
                :title="'品种列表'"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="onPzConfirm()"
                v-if="dialogVisible"
                :append-to-body="true">
            <pz-list :dataOrd="dataOrd" @onPzConfirm="onPzConfirm"></pz-list>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import pzList from "./pzList";
    export default {
        provide(){
            return {
                form:this
            }
        },
        components: {
            pzList,
        },
        props: {
            Data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                tableHeight: 400,
                maxDialogHeight: 0,
                dataOrd:{},
                i_id:0,
                formData: {
                    vc_lruname: sessionStorage.getItem("lruname"),
                    dt_createtime: '',
                    i_state:0,
                    dt_starttime:'',
                    dt_endtime:'',
                    i_gsid:0,
                    vc_gsname:'',
                    i_khid:0,
                    vc_khname:'',

                    i_sell_uid:0,
                    vc_sell_uname:'',
                    i_sell_deptId:0,
                    vc_sell_deptName:'',
                    i_purchase_uid:0,
                    vc_purchase_uname:'',
                    i_purchase_deptId:0,
                    vc_purchase_deptName:'',
                },
                kh_gsid:0,
                tableData: [],
                delIds:[],
                compsData:[],
                khData:[],
                personName:[],
                groupName:[],
                personName_cg:[],
                groupName_cg:[],
                loading:false,
                dialogVisible:false,
                disabled:false,
                disabled_gs:false,
                disabled_kh:false,
                disabled_time:false,
                gosave:false,
                baseerp:'',
                baseApp:'',
                baseVersion:'',
                file_url:'',
                file_root:'',
                file:'',
                token:'',
                i_uid:'',
                /*pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7 // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },*/
                /*pickerOptions2: {
                    disabledDate(time) {
                        if(!this.formData.dt_starttime) return false;
                        const start = new Date(this.formData.dt_starttime).setHours(0,0,0,0);
                        return time.getTime() < start // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },*/
                backtype:'back',
            }
        },
        computed: {
            pickerOptions(){
                return {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7 // 如果要禁用到当前日期则去掉 - 8.64e7
                    },
                }

            },
            pickerOptions2(){
                const startT = this.formData&&this.formData.dt_starttime?new Date(this.formData.dt_starttime).setHours(0,0,0,0):null
                return {
                    disabledDate(time) {
                        if(!startT) return false;
                        return time.getTime() < startT // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                }

            },
        },
        watch:{
            'formData.dt_starttime'(newval){
                if(this.formData.dt_endtime&&this.formData.dt_endtime<newval){
                    this.formData.dt_endtime=''
                }
            }
        },
        mounted() {
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file = this.file_url;
            this.token = sessionStorage.getItem('token');
            this.i_uid = sessionStorage.getItem('userid');
            //console.log(this.Data, 'this.Data');
            this.type = this.Data.type;
            this.getCompanyList();
            this.getkhlist();
            if (this.type == 'add') {
                this.i_id=0;
                this.getDateYYYYMMddHHMMSS()
                this.updateTableHeight();
                window.addEventListener('resize', this.updateTableHeight);
            };
            if (this.type == 'edit'||this.type == 'watch') {
                //console.log('this.Data',this.Data)
                this.i_id=this.Data.row.i_id;
                this.kh_gsid=this.Data.row.i_kh_companyid;
                this.formData=JSON.parse(JSON.stringify( this.Data.row));
                this.disabled=this.type == 'edit'?false:true;
                this.disabled_gs=this.type == 'edit'?false:true;
                this.disabled_kh=true;
                this.disabled_time=true;
                this.getGroupList('gs',this.formData.i_gsid?this.formData.i_gsid:0);
                this.getGroupList('kh',this.formData.customerCompanyId?this.formData.customerCompanyId:0);
                this.getPersonList('xs',this.formData.i_sell_deptId?this.formData.i_sell_deptId:0);
                this.getPersonList('cg',this.formData.i_purchase_deptId?this.formData.i_purchase_deptId:0);
                this.detail()
            };
            if(this.type == 'copy'){
                this.i_id=this.Data.row.i_id;
                this.kh_gsid=this.Data.row.i_kh_companyid;
                this.formData=JSON.parse(JSON.stringify( this.Data.row));
                this.disabled=false;
                this.disabled_gs=true;
                this.disabled_kh=true;
                this.disabled_time=false;
                this.getGroupList('gs',this.formData.i_gsid?this.formData.i_gsid:0);
                this.getGroupList('kh',this.formData.customerCompanyId?this.formData.customerCompanyId:0);
                this.getPersonList('xs',this.formData.i_sell_deptId?this.formData.i_sell_deptId:0);
                this.getPersonList('cg',this.formData.i_purchase_deptId?this.formData.i_purchase_deptId:0);
                this.detail('copy')
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.Data.maxDialogHeight,'this.Data.maxDialogHeight');
                const dialogHeight = this.Data.maxDialogHeight * 0.95;
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =350;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.Data.maxDialogHeight;
            },
            toVoid(){
                if(this.gosave==true){this.$message.error('修改数据后请先保存！');return;}
                this.$confirm(this.$t('是否确认作废？'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.submit(-1);
                }).catch(() => {
                });},
            toApprove(){
                if(this.gosave==true){this.$message.error('修改数据后请先保存！');return;}
                this.$confirm(this.$t('是否确认提交？'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.submit(1);
                }).catch(() => {
                });},
            addpz(){
                if (this.formData.i_gsid==0||this.formData.i_khid==0||this.formData.dt_starttime==''||this.formData.dt_endtime=='') {this.$message.error('公司/客户/开始日期/结束日期不能为空');return;}
                this.dataOrd={
                    maxDialogHeight:this.maxDialogHeight,
                    i_gsid:this.formData.i_gsid,
                    i_khid:this.formData.i_khid,
                    dt_starttime:this.formData.dt_starttime,
                    dt_endtime:this.formData.dt_endtime,
                    select:this.tableData,
                    del:this.delIds,
                }
                this.dialogVisible=true;
            },
            deleteRow(value, index) {
                this.tableData.splice(index, 1);
                if (value.i_id) {
                    this.delIds.push(value.i_id);
                    this.gosave=true;
                    //console.log('this.delIds--wai', this.delIds)
                };
            },
            onPzConfirm(diff,type){
                if(type)this.gosave=true;
                this.dialogVisible=false;
                this.dataOrd={};
                if(diff){
                    const { addList, editList, delIds , removeList} = diff;
                    this.delIds=[...new Set([...this.delIds, ...delIds])];
                    this.tableData = this.tableData.filter(row => {
                        if (row.i_id && delIds.includes(row.i_id)) return false;
                        if (!row.i_id && removeList.some(r => r.i_pzid === row.i_pzid)) return false;
                        return true;
                    });
                    editList.forEach(edit => {
                        const index = this.tableData.findIndex(p => p.i_pzid === edit.i_pzid);
                        if (index !== -1) {
                            this.$set(this.tableData, index, {
                                ...this.tableData[index],
                                ...edit
                            });
                        }
                    });
                    addList.forEach(item => {
                        this.tableData.push({
                            ...item,
                            //i_id: null
                        });
                    });
                    //console.log('this.delIds--nei',this.delIds)
                }
            },
            cancel(){this.$emit('confirm',{type:this.backtype})},
            async submit(state) {
                this.loading = true;
                let param = {
                    i_mid: this.mid,
                    i_id: this.i_id,
                    i_state:state,
                };
                let res = await API.updateListPriceState(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.detail();
                    //this.backtype = 'save';
                    //this.cancel();
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            refreshTable() {
                this.showTable = false;
                this.$nextTick(() => {
                    this.showTable = true;
                })
            },
            async detail(type) {
                let param = {
                    i_id: this.i_id,
                };
                let res = await API.PzDetail(param);
                if (res.code == 1) {
                    if(type=='copy'){
                        this.i_id=0;
                        this.disabled=false;
                        this.disabled_gs=true;
                        this.disabled_kh=true;
                        this.disabled_time=false;
                        this.formData.i_state=0;
                        this.formData.dt_starttime='';
                        this.formData.dt_endtime='';
                        res.data.queryListPricePzDetails.map(item=>{if(item.f_open_price){item.f_list_price=item.f_open_price}});
                        this.tableData=res.data.queryListPricePzDetails;
                    }else{
                        this.disabled=res.data.i_state == 0?false:true;
                        this.disabled_gs=res.data.i_state == 0?false:true;
                        this.disabled_kh=true;
                        this.disabled_time=true;
                        this.formData.i_state=res.data.i_state;
                        this.tableData=res.data.queryListPricePzDetails;
                    }
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            buzero(result) {
                let result1 = result + '';
                if (result1.indexOf('.') == '-1') {
                    result1 = result1 + '.00'
                }
                return result1
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            saveForm() {
                if (this.tableData.length == 0) {
                    this.$message.error('请选择挂牌品种');
                    return;
                }else {
                    let has0 = this.tableData.some(item=>item.f_list_price==0)
                    if(has0){this.$message.error('挂牌价不可为0');return;}
                }
                /*if (this.formData.i_sell_deptId==0||this.formData.i_sell_uid==0||this.formData.i_purchase_deptId==0||this.formData.i_purchase_uid==0) {
                    this.$message.error('销售/采购的部门和人员不能为空');
                    return;
                }*/
                if (this.formData.i_gsid==0||this.formData.i_khid==0||this.formData.dt_starttime==''||this.formData.dt_endtime=='') {
                    this.$message.error('公司/客户/开始日期/结束日期不能为空');
                    return;
                }
                this.saveListPrice();
            },
            async saveListPrice() {
                this.loading = true;
                let param = {
                    i_id:this.i_id,
                    i_gsid:this.formData.i_gsid,
                    vc_gsname:this.formData.vc_gsname,
                    i_khid:this.formData.i_khid,
                    vc_khname:this.formData.vc_khname,
                    dt_starttime:this.formData.dt_starttime+' 00:00:00',
                    dt_endtime:this.formData.dt_endtime+' 23:59:59',
                    priceRecordSubList:this.tableData,
                    delSubIds:this.delIds,
                    i_sell_uid:this.formData.i_sell_uid,
                    vc_sell_uname:this.formData.vc_sell_uname,
                    i_sell_deptId:this.formData.i_sell_deptId,
                    vc_sell_deptName:this.formData.vc_sell_deptName,
                    i_purchase_uid:this.formData.i_purchase_uid,
                    vc_purchase_uname:this.formData.vc_purchase_uname,
                    i_purchase_deptId:this.formData.i_purchase_deptId,
                    vc_purchase_deptName:this.formData.vc_purchase_deptName,
                };
                let res = await API.saveListPrice(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.gosave=false;
                    this.delIds=[];
                    this.i_id=res.data;
                    this.backtype='save';
                    this.detail()
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            inprice(data,index,row){
                if(row.f_list_price <= 0){
                    row.f_list_price = 0;
                    this.$set(data,index,row);
                    this.$message.error('挂牌价不可小于等于0');
                    this.refreshTable();
                    return ;
                }
                this.gosave=true;
                this.$set(data,index,row);
            },
            getDateYYYYMMddHHMMSS() {
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime = `${date.getFullYear()}-${month}-${strDate}`;
            },
            async getPersonList(type,id){
                return; //20260126 挂牌去除部门人员
                let param={
                    i_groupid:id,
                    isAll:0,
                    isNoRight:0,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    console.log(type,'type')
                    if(type=='xs'){
                        this.personName=res.data;
                        if(res.data.length==1){
                            this.formData.i_sell_uid=res.data[0].i_id;
                            this.formData.vc_sell_uname=res.data[0].vc_name;
                        }
                    }
                    if(type=='cg'){
                        this.personName_cg=res.data;
                        if(res.data.length==1){
                            this.formData.i_purchase_uid=res.data[0].i_id;
                            this.formData.vc_purchase_uname=res.data[0].vc_name;
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(type,id){
                return; //20260126 挂牌去除部门人员
                let param={
                    i_mid: this.mid,
                    i_gsid:id,
                    //isAll:1
                    isNoRight:0,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    if(type=='gs'){
                        this.groupName=res.data;
                        if(res.data.length==1){
                            this.formData.i_sell_deptId=res.data[0].i_id;
                            this.formData.vc_sell_deptName=res.data[0].vc_name;
                            this.getPersonList('xs',this.formData.i_sell_deptId)
                        }
                    }
                    if(type=='kh'){
                        this.groupName_cg=res.data;
                        if(res.data.length==1){
                            this.formData.i_purchase_deptId=res.data[0].i_id;
                            this.formData.vc_purchase_deptName=res.data[0].vc_name;
                            this.getPersonList('cg',this.formData.i_purchase_deptId)
                        }
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getkhlist() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.khData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            issameid(gs,kh){
                if(gs==kh){this.$message.error('公司和客户不能为同一个');return true;}
                return false;
            },
            changeData(e, type) {
                if (type == 'kh') {
                    this.formData.i_khid = e;
                    let choo = this.khData.filter(item => {
                        return item.i_khid == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_khname = choo[0].vc_khname;
                        this.kh_gsid = choo[0].i_gsid;
                    } else {
                        this.formData.vc_khname = '';
                        this.kh_gsid = 0;
                    }
                    let thesame = this.issameid(this.formData.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.formData.i_khid = 0;
                        this.formData.vc_khname = '';
                    }
                    this.groupName_cg=[];
                    this.formData.i_purchase_deptId = 0;
                    this.formData.vc_purchase_deptName=''
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                    this.getGroupList(type,this.kh_gsid==''?0:this.kh_gsid)
                }
                if (type == 'gs') {
                    this.formData.i_gsid = e;
                    let choo = this.compsData.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_gsname = choo[0].vc_name;
                    } else {
                        this.formData.vc_gsname = '';
                    }
                    let thesame = this.issameid(this.formData.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.formData.i_gsid = 0;
                        this.formData.vc_gsname = "";
                    }
                    this.groupName=[];
                    this.formData.i_sell_deptId = 0;
                    this.formData.vc_sell_deptName='';
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                    this.getGroupList(type,this.formData.i_gsid==''?0:this.formData.i_gsid)
                }
                if (type == 'xsbm') {
                    this.formData.i_sell_deptId = e;
                    let choo = this.groupName.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_sell_deptName=choo[0].vc_name;
                    } else {
                        this.formData.vc_sell_deptName='';
                    }
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                    this.getPersonList('xs',this.formData.i_sell_deptId==''?0:this.formData.i_sell_deptId)
                }
                if (type == 'xsper') {
                    this.formData.i_sell_uid = e;
                    let choo = this.personName.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_sell_uname=choo[0].vc_name;
                    } else {
                        this.formData.vc_sell_uname=''
                    }
                }
                if (type == 'cgbm') {
                    this.formData.i_purchase_deptId = e;
                    let choo = this.groupName_cg.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_purchase_deptName=choo[0].vc_name;
                    } else {
                        this.formData.vc_purchase_deptName=''
                    }
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                    this.getPersonList('cg',this.formData.i_purchase_deptId==''?0:this.formData.i_purchase_deptId)
                }
                if (type == 'cgper') {
                    this.formData.i_purchase_uid = e;
                    let choo = this.personName_cg.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_purchase_uname=choo[0].vc_name;
                    } else {
                        this.formData.vc_purchase_uname=''
                    }
                }
                if (type == 'starttime') {
                    this.formData.dt_starttime=e;
                }
                if (type == 'endtime') {
                    this.formData.dt_endtime=e;
                }
                if(this.type != 'copy'){
                    this.tableData.map(item=>{ if(item.i_id){this.delIds.push(item.i_id)}});
                    this.tableData=[];
                    this.gosave=true;
                }
            },
            changeData(e, type) {
                if (type == 'kh') {
                    this.formData.i_khid = e;
                    let choo = this.khData.filter(item => {
                        return item.i_khid == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_khname = choo[0].vc_khname;
                        this.kh_gsid = choo[0].i_gsid;
                    } else {
                        this.formData.vc_khname = '';
                        this.kh_gsid = 0;
                    }
                    let thesame = this.issameid(this.formData.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.formData.i_khid = 0;
                        this.formData.vc_khname = '';
                    }
                    this.groupName_cg=[];
                    this.formData.i_purchase_deptId = 0;
                    this.formData.vc_purchase_deptName=''
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                    this.getGroupList(type,this.kh_gsid==''?0:this.kh_gsid)
                }
                if (type == 'gs') {
                    this.formData.i_gsid = e;
                    let choo = this.compsData.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_gsname = choo[0].vc_name;
                    } else {
                        this.formData.vc_gsname = '';
                    }
                    let thesame = this.issameid(this.formData.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.formData.i_gsid = 0;
                        this.formData.vc_gsname = "";
                    }
                    this.groupName=[];
                    this.formData.i_sell_deptId = 0;
                    this.formData.vc_sell_deptName='';
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                    this.getGroupList(type,this.formData.i_gsid==''?0:this.formData.i_gsid)
                }
                if (type == 'xsbm') {
                    this.formData.i_sell_deptId = e;
                    let choo = this.groupName.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_sell_deptName=choo[0].vc_name;
                    } else {
                        this.formData.vc_sell_deptName='';
                    }
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                    this.getPersonList('xs',this.formData.i_sell_deptId==''?0:this.formData.i_sell_deptId)
                }
                if (type == 'xsper') {
                    this.formData.i_sell_uid = e;
                    let choo = this.personName.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_sell_uname=choo[0].vc_name;
                    } else {
                        this.formData.vc_sell_uname=''
                    }
                }
                if (type == 'cgbm') {
                    this.formData.i_purchase_deptId = e;
                    let choo = this.groupName_cg.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_purchase_deptName=choo[0].vc_name;
                    } else {
                        this.formData.vc_purchase_deptName=''
                    }
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                    this.getPersonList('cg',this.formData.i_purchase_deptId==''?0:this.formData.i_purchase_deptId)
                }
                if (type == 'cgper') {
                    this.formData.i_purchase_uid = e;
                    let choo = this.personName_cg.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_purchase_uname=choo[0].vc_name;
                    } else {
                        this.formData.vc_purchase_uname=''
                    }
                }
                if (type == 'starttime') {
                    this.formData.dt_starttime=e;
                }
                if (type == 'endtime') {
                    this.formData.dt_endtime=e;
                }
                if(this.type != 'copy'&&!(type == 'xsbm'||type == 'xsper'||type == 'cgbm'||type == 'cgper')){
                    this.tableData.map(item=>{ if(item.i_id){this.delIds.push(item.i_id)}});
                    this.tableData=[];
                    this.gosave=true;
                }
            },
            clearsearch(type) {
                if (type == 'kh') {
                    this.formData.i_khid = 0;
                    this.formData.vc_khname = '';
                    this.kh_gsid = 0;
                    this.groupName_cg=[];
                    this.formData.i_purchase_deptId = 0;
                    this.formData.vc_purchase_deptName=''
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                }
                if (type == 'gs') {
                    this.formData.i_gsid = 0;
                    this.formData.vc_gsname = "";
                    this.groupName=[];
                    this.formData.i_sell_deptId = 0;
                    this.formData.vc_sell_deptName='';
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                }
                if (type == 'xsbm') {
                    this.formData.i_sell_deptId = 0;
                    this.formData.vc_sell_deptName='';
                    this.personName=[];
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                }
                if (type == 'xsper') {
                    this.formData.i_sell_uid = 0;
                    this.formData.vc_sell_uname=''
                }
                if (type == 'cgbm') {
                    this.formData.i_purchase_deptId = 0;
                    this.formData.vc_purchase_deptName=''
                    this.personName_cg=[];
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                }
                if (type == 'cgper') {
                    this.formData.i_purchase_uid = 0;
                    this.formData.vc_purchase_uname='';
                }
                this.gosave=true;
            },
        },
    }
</script>


<style lang="scss" scoped>
    .minW58{
        min-width: 58px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }
    .popaddbtn{
        border: none;
        padding: 0;
    }
    .form-title{
        //flex: 1 1 50%;
        padding-right: 20px;
        padding-left: 10px;
        display: flex;
    }
    .flex{
        display: flex;
    }
    .alc{
        align-items: center;
    }
    .w100{
        width: 100%;
    }
    .marT10{
        margin-top: 10px;
    }
    .w50{
        width: 50%;
    }
    .marr4{
        margin-right: 4px;
    }
    .font14{
        font-size: 14px;
    }
    .txtE{
        text-align: end;
    }
    .txt{
        text-align: center;
    }
    .txtS{
        text-align: start;
    }
</style>